module.exports = __webpack_public_path__ + "img/western-wood-pewee.6085c264.jpg";